import React, { useEffect, useState } from "react";
import { Col, Container, Row, Form } from "react-bootstrap";
import FormLabel from "./FormLabel";
import Select from "react-select";
import { alertModal } from "../utils/modalController";
import styles from "./NewConsultForm.module.scss";
import { fetchAuth } from "../utils/fetchAuth";

type NewConsultFormProps = {
    patient: User | null;
    onChange?: (data: {contrato_id: string; date: string} ) => void;
};

const apiUrl = process.env.REACT_APP_API_URL || '';

export const NewConsultForm: React.FC<NewConsultFormProps> = ({
    patient,
    onChange = () => { },
}) => {
    const [contrato, setContrato] = useState<ConsultationPackages | null>(null);
    const [contratos, setContratos] = useState<ConsultationPackages[]>([]);
    const [selectedDate, setSelectedDate] = useState<string>("");
    const nowDate = new Date();
    nowDate.setHours(nowDate.getHours() - 3); // Ajuste de fuso horário para UTC-3
    const formattedDate = nowDate.toISOString().slice(0, 16); // Format to 'YYYY-MM-DDTHH:MM'

    useEffect(() => {
        fetchAuth(`${apiUrl}/consultorio/patients/${patient?.patient?.id}/consultation-packages`)
            .then(async (res) => {
                if (!res.ok) {
                    const error = await res.json();
                    throw new Error(error.message || 'Erro ao buscar contratos');
                }
                return res.json();
            })
            .then((data) => {
                setContratos(data);
            })
            .catch((error) => {
                console.error("Erro ao buscar contratos:", error);
                alertModal("Erro ao buscar contratos: " + error.message);
            });
    }, [patient]);

    return (
        <Container className="mb-3">
            <Row>
                <Col md={6}>
                    <FormLabel htmlFor="data" required={true}>
                        Data:
                    </FormLabel>
                    <Form.Control
                        type="datetime-local"
                        className={styles["input-control"]}
                        id="data"
                        name="data"
                        onChange={(e) => {
                            const dateValue = e.target.value;
                            setSelectedDate(dateValue);
                            if (onChange) {
                                onChange({
                                    date: dateValue,
                                    contrato_id: String(contrato?.id) || "",
                                });
                            }
                        }}
                        required
                        defaultValue={formattedDate}
                    />
                </Col>

                <Col md={6}>
                    <FormLabel htmlFor="contrato" required={true}>
                        Contrato:
                    </FormLabel>
                    <Select
                        id="contrato"
                        name="contrato"
                        classNames={{
                            control: (state) => `${styles['select-control']} ${state.isFocused ? styles['focused'] : ''}`,
                            menu: () => styles['select-menu'],
                            option: (state) => `${styles['select-option']} ${state.isSelected ? styles['selected'] : ''}`,
                            container: () => styles['select-container'],
                        }}
                        required
                        value={
                            contrato
                                ? { value: contrato.id, label: contrato.title }
                                : null
                        }
                        onChange={(option) => {
                            setContrato(
                                contratos.find((c) => c.id === option?.value) || null
                            );
                            if (onChange) onChange({
                                date: selectedDate,
                                contrato_id: String(option?.value) || "",
                            });

                        }}
                        options={contratos
                            .filter((c) => {
                                const validade = c.valid_date ? new Date(c.valid_date) : null;
                                return (
                                    (c.paymentStatus === "approved" || (c.valor ?? 0) === 0) &&
                                    (c.sessions_left > 0 || (c.number_of_sessions ?? 0) === 0) &&
                                    (!validade || validade > new Date())
                                );
                            })
                            .map((c) => ({
                                value: c.id,
                                label: c.title,
                            }))}
                        isClearable
                    />

                </Col>
            </Row>
        </Container>
    );
};
